// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ListRoot = styled.ul``;
